// 忘記密碼頁面翻譯
export default {
  title: "找回密碼",
  subtitle: "請輸入手機號並完成簡訊驗證以重置密碼",
  contactServiceText: "帳號登入用戶忘記密碼請",
  contactService: "聯繫客服",
  sendCode: "發送驗證碼",
  sendCodeAgain: "重新發送",
  backToLogin: "返回登入",
  nextStep: "下一步",
  resetPassword: "重置密碼",
  resetSuccess: "密碼重置成功",
  resetFailed: "密碼重置失敗",
  codeExpired: "驗證碼已過期",
  countdown: "{seconds}秒後重新發送",
  form: {
    codeRequired: "請先獲取驗證碼",
    confirmNewPasswordRequired: "請再次確認新密碼",
    passwordMismatch: "兩次輸入的密碼不一致",
  },
  buttons: {
    getCaptcha: "獲取驗證碼",
    confirm: "確認",
    cancel: "返回",
  },
  steps: {
    step1: "輸入郵箱",
    step2: "驗證身份",
    step3: "設置新密碼",
  },
};
